export class ExternalImageValidationError extends Error {}
